import React, { Component } from 'react'
import numeral from 'numeral'
import { includes } from 'lodash'
import alertService from '../services/alert.service'
import CasePickerItem, {
  CasePickerItemStatus, CasePickerItemSize
} from './CasePickerItem'
import InputText, { InputTextRef } from './InputText'

interface BundleScannerProps {
  size: CasePickerItemSize
  status: CasePickerItemStatus
  label?: string
  position?: number
  className?: string
  scannedCodes?: string[]
  inputRef: InputTextRef
  onBundleScan?: (position: number, scan: string) => void
  onCaseScan?: (scan: string) => void
  onScanError: boolean
  onScanErrorCallback: () => void
}

interface BundleScannerState {
  scan: string
}

export default class BundleScanner
  extends Component<BundleScannerProps, BundleScannerState> {
  constructor (props: BundleScannerProps) {
    super(props)
    this.state = {
      scan: ''
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputScan = this.handleInputScan.bind(this)
  }

  get className () {
    const base = 'inline-block'
    const size = (this.props.size === 'double') ? 'w-56' : 'w-28'
    return `${base} ${size} ${this.props.className}`
  }

  get placeholder () {
    const { position, label } = this.props
    const ordinal = numeral(position).format('0o')
    const positionPlaceholder = `${ordinal} pack`
    return position
      ? positionPlaceholder
      : label || ''
  }

  get inputTextName () {
    const { position, label } = this.props
    return position
      ? position.toString()
      : label || ''
  }

  isCodeScanned (code: string) {
    return includes(this.props.scannedCodes, code)
  }

  handleInputChange (name: string, scan: string) {
    this.setState({ scan })
  }

  handleInputScan (name: string, scan: string) {
    if (!scan) return
    if (this.isCodeScanned(scan)) {
      alertService.warning('Duplicate scan')
      this.setState({ scan: '' })
      return
    }
    const { onBundleScan, onCaseScan, position, label } = this.props
    onBundleScan && position && onBundleScan(position, scan)
    onCaseScan && label && onCaseScan(scan)
  }

  render () {
    if(this.props.onScanError){
      this.setState({ scan: '' })
      this.props.onScanErrorCallback()
    }
    return (
      <div className={this.className}>
        <div className="mb-3">
          <CasePickerItem
            size={this.props.size}
            status={this.props.status}
            label={this.props.label}
            position={this.props.position} />
        </div>
        <InputText
          name={this.inputTextName}
          value={this.state.scan}
          placeholder={this.placeholder}
          customRef={this.props.inputRef}
          readonly={this.props.status !== 'available'}
          onChange={this.handleInputChange}
          onScan={this.handleInputScan} />
      </div>
    )
  }
}
